import {SoftDeleteEntity} from './soft-delete-entity';
import {Customer} from './customer';
import {Product} from './product';
import {CardActivation} from './card-activation';
import {CardCreation} from './card-creation';
import {CardComment} from './card-comment';
import {Sepa} from './sepa';
import {Sofort} from './sofort';
import {Order} from './order';
import {CardReorderReason} from './card-reorder-reason';
import {GpsCardStatus} from './gps-card-status';
import {CashbackGroupMembership} from './cashbackGroup';
import {ObjectComment} from './object-comment';
import {FormGroup} from '@angular/forms';
import {Statement, StatementLineDto} from "./CardbroGateway/statement";
import {CardHolderDetails} from './CardbroGateway/cardholder-details';
import {CardCashbackSummary, CardInfo} from './CardbroGateway/card-info';
import {BaseEntity} from './base-entity';
import {CardConversionStatus, CardUsageStatus} from "./ident-status";
import {CardReorder} from './cardReorder';
import {CardInfoModelBase, CardType} from "./cardInfoModelBase";
import {CardStatus} from "./cardStatus";
import {MatTableDataSource} from "@angular/material/table";
import {Transaction, TransactionEx} from "./CardbroGateway/transaction";
import {Upload} from "./upload";
import {GPSPosData} from "../helpers/gps-pos-data-helper";

export class CardBase extends SoftDeleteEntity {
  public token: string;
  public customerId: number;
  public cardType: CardType;
  public cardTypeName: String;
  public productId: number;
}

export class Card extends CardBase {

  public recId: string;
  public invoiceId: number;
  public orderId: number;
  public order: Order;

  public customer: Customer;
  public product: Product;
  public status: number;
  public statusName: string;
  public cardName: string;
  public comment: string;
  public orderDate: Date;
  public shippedDate: Date;
  public orderCancellationDate: Date;
  public pullDate: Date;
  public creationDate: Date;
  public activationDate: Date;
  public replacementId: number;

  public productName: string|null;
  public productShortName: string|null;
  public productInternalName: string|null;
  public productKey: string|null;
  public companyName: string|null;
  public expireDate: Date;
  public cardCreations: CardCreation[];
  public cardActivations: CardActivation[];
  public cardComments: CardComment[];

  public cashbackGroupMemberships: CashbackGroupMembership[];

  public reorderReason: CardReorderReason;
  public reorderComment: string;

  public sepas: Sepa[];
  public soforts: Sofort[];

  public maskedPAN: String;

  public tempToken: string;
  public tempExpiryDate: Date;

  public isMigrated: boolean;
  public migratedFromToken: string;
  public migratedFromExpireDate: Date;

  public nextAnnualFeeDate: Date|null; // use this for internal processing
  public nextAnnualFeeDateDisplayed: Date|null; // use this for external display

  public gpsCardStatus: GpsCardStatus|null;
  public gpsCardStatusBeforeExpiry: GpsCardStatus|null;
  public gpsCardStatusDate: Date|null;


  public usageStatus: CardUsageStatus;

  public primaryToken: string|null;
  public primaryCardId: number|null;
  public primaryCard: Card|null;

  public isExtensionPending: boolean;
  public isQueuedForConversion: boolean;

  public isVirtualOnly: boolean;
  public displayColor: string|null;
  public displayName: string|null;

  public cashbackFactorOverride: number|null = null;
  public cashbackFactorOverrideExpiry: Date|null = null;


  hasPromotionalAnnualFee: boolean = false;
  promotionalAnnualFeeReason: string|null= null;
  promotionalAnnualFeeEndDate: Date|null;

  promotionalAnnualFee : number|null;
  promotionalAnnualFeeFromSecondYear : number|null;

  blackListCode: string|null;
  whiteListCode: string|null;

  autoCloseDate: Date|null;


}

export class CustomerOverviewCardContainer {

  public card: Card;
  public pendingExtension: CardExtension|null;
  public pendingReorder: CardReorder|null;
  public extensions: CardExtension[];
  public cashbackSummary: CardCashbackSummary;
  public gpsCardStatusCached: GpsCardStatus;


  public invoiceComments: Array<ObjectComment>;

  public id: number;

  public editVisible: boolean;
  public editForm: FormGroup;
  public statement: Statement;
  public financialStatements: MatTableDataSource<TransactionEx>;
  public cardholderDetails: CardHolderDetails;
  public cardInfo: CardInfo;
  public lastKnownAvailableBalance: number|null;
  public statement2: StatementLineDto[]|null;
  public statement2DataSource: MatTableDataSource<StatementLineDto>|null;
  public gpsPosDataList: Map<string, GPSPosData> = new Map<string, GPSPosData>();



}

export class CardExtension extends BaseEntity {
  public cardId: number;
  public card: Card|null;
  public extensionDate: Date;
  public oldExpiryDate: Date|null;
  public newCvv: string;
  public newExpiryDate: Date|null;

  public isActivated: boolean;
  public activationDate: Date|null;

  public status: number;

}

export class CardStatusInfo extends CardBase
{
  status: CardStatus;
  gpsCardStatus: string;
  gpsCardStatusBeforeExpiry: string;
  public statusName: string;
  public productName: string|null;
}

export class CardWithSecondaries extends Card {
  secondaryCards: CardStatusInfo[];
}


export class Chargeback extends BaseEntity {
  externalRef: string;
  creationDate: Date;
  cardId: number;
  card: Card;
  customerId: number;
  customer: Customer;
  status: ChargebackStatus;
  transactionAmount: number;
  merchantName: string;
  transactionDate?: Date;
  cardDetailsShared: boolean;
  merchantContactDate?: Date;
  securityProcedure: SecurityProcedure;
  reason: ChargebackReason;
  cardState: ChargebackCardState;
  previousPurchaseAtMerchant: boolean;
  visitedCountryLast12m: boolean;
  otherPersonsDeviceAccess: boolean;
  confirmNoKnowledgeOfIdentity: boolean;
  confirmNoRunningContract: boolean;
  confirmInformationAboutFees: boolean;
  confirmTruthful: boolean;
  metaTxnId: number;
  otherMetaTxnIds: number[] = [];
  isCommited: boolean = false;


}

export enum ChargebackReason {
  UnauthorizedPayment = 1,
  UnauthorizedAmount = 2,
  MultipleDebits = 3,
  GoodsServiceNotProvided = 4,
  NoCreditAfterReturn = 5,
  CounterfeitDefective = 6,
  DebitAfterCancellation = 7,
  Other = 99,
}

export enum ChargebackCardState {
  HaveCard = 1,
  LostCard = 2,
  StolenCard = 3,
}

export enum SecurityProcedure {
  ContactlessWithoutPin = 1,
  CardPaymentWithPin = 2,
  OnlinePaymentWithCvv = 3,
  OnlinePaymentWithCvv3Ds = 4,
  NotKnown = 99,
}

export enum ChargebackStatus {
  Request = 0,
  Pending = 1, // in progress
  Denied = 2,
  SuccessPending = 3,
  ChargebackExecuted = 4,
}

export enum ChargebackFileType {
  Unknown = 0,
  MerchantCommunication = 1,
  PurchaseConfirmation = 2,
  PoliceReport = 3,
}

export class ChargebackToFile {
  chargebackId: number;
  chargeback: Chargeback; // You will need to define the Chargeback entity
  fileId: number;
  file: Upload; // You will need to define the Upload entity
  clientIp: string;
  fileType: ChargebackFileType;
}

export class CardConversion {
  card: Card;
  cardId: number;
  status: CardConversionStatus;
  queueDate: Date;
  executionDate: Date|null;
  failedDate: Date|null;
  executionActionCode: string|null;
  fromType: CardType;
  toType: CardType;
}

export class CardIssueResultDto
{
  newPublicToken: string;
  newExpiryInt: number;
  newCardType: CardType
  newMaskedPan: string;
}
